export default __webpack_public_path__ + "static/media/bground1.b3d4c01a.png";